// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splendi-logo {
	width: 80%;
}

h-10{
    height: 10% !important;
}

.header {
  /* background-color: white; */
  min-height: 3vh;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center; 
  font-size: calc(5px + 2vmin);
  color: black !important;
  justify-content: space-between;
}
.account{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 1 1;
    padding-left: 1vh;
    margin-right:5%;
}

@media (max-width: 540px) {
	.splendi-logo {
		width: 80%;
	}

	.navigation-item {
		font-size: x-small;
	}

	/* If more nav items are added, decrease the font size from small to x-small */
	.navigation-item-public {
		font-size: small;
	}

	.navbar-button {
		font-size: small;
	}
}`, "",{"version":3,"sources":["webpack://./src/_components/nav/nav.css"],"names":[],"mappings":"AAAA;CACC,UAAU;AACX;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,eAAe;AACnB;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,kBAAkB;CACnB;;CAEA,8EAA8E;CAC9E;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".splendi-logo {\n\twidth: 80%;\n}\n\nh-10{\n    height: 10% !important;\n}\n\n.header {\n  /* background-color: white; */\n  min-height: 3vh;\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; \n  font-size: calc(5px + 2vmin);\n  color: black !important;\n  justify-content: space-between;\n}\n.account{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    flex: 1;\n    padding-left: 1vh;\n    margin-right:5%;\n}\n\n@media (max-width: 540px) {\n\t.splendi-logo {\n\t\twidth: 80%;\n\t}\n\n\t.navigation-item {\n\t\tfont-size: x-small;\n\t}\n\n\t/* If more nav items are added, decrease the font size from small to x-small */\n\t.navigation-item-public {\n\t\tfont-size: small;\n\t}\n\n\t.navbar-button {\n\t\tfont-size: small;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
